import { render, staticRenderFns } from "./SwHeader.vue?vue&type=template&id=23a993ba&scoped=true&"
import script from "./SwHeader.vue?vue&type=script&lang=js&"
export * from "./SwHeader.vue?vue&type=script&lang=js&"
import style0 from "./SwHeader.vue?vue&type=style&index=0&id=23a993ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a993ba",
  null
  
)

export default component.exports